// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"64aababc","732":"a38800b4","977":"9bac61a3"}[chunkId] + ".chunk.js";
};